import classNames from "classnames";
import { FC } from "react";

export const FormError: FC<{ id?: string; error?: string }> = ({ error, id = "form-error" }) => {
  return (
    <p
      data-cy={id}
      data-testid={id}
      role="alert"
      className={classNames("mt-2 pl-2 text-sm text-left text-red-500", {
        hidden: !error
      })}
    >
      {error}
    </p>
  );
};
